import { Breadcrumb, Button, Col, Row, Typography } from "antd";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import PatientMedicineTable from "../../../components/Tables/PatientMedicinesTable";
import { translate } from "../../../locale";
import UserServices from "../../../services/UserServices";

const { Title } = Typography;

const PatientMedicine = () => {
  const navigate = useNavigate();
  const { username } = useParams();
  const [patientInfo, setPatientInfo] = useState(null);

  useEffect(() => {
    const fetchPatientInfo = async () => {
      try {
        const response = await UserServices.getProfile(username);
        if (response.status >= 200 && response.status < 300) {
          setPatientInfo(response.data.my_contact_info);
        }
      } catch (error) {
        console.error('fetchPatientInfo error: ', error);
      }
    };
    fetchPatientInfo();
  }, [username]);

  return (
    <div className="flex flex-col items-start min-h-full w-screen max-w-7xl pb-16 m-10">
      <Row gutter={16} className="w-full">
        <Col className="gutter-row" span="20">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">Inicio</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/admin/buscar-paciente/${username}`}>
                {translate("Resumen individual")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>Medicamentos del Paciente</Breadcrumb.Item>
            {patientInfo && (
              <Breadcrumb.Item>
                {patientInfo.first_name} {patientInfo.last_name} - {username}
              </Breadcrumb.Item>
            )}
          </Breadcrumb>
        </Col>
        <Col span={24} className="my-4">
          <Title level={2} className="text-center">
            Medicamentos del Paciente
          </Title>
        </Col>
        <Col span={24}>
          <Button
            id="boton_id_para_franco"
            type="primary"
            className="px-10 bg-white text-black my-6"
            onClick={() => {
              navigate(
                `/admin/medicamentos/buscar/${encodeURIComponent(
                  "/admin/buscar-paciente/" + username
                )}/${username}`
              );
            }}
          >
            Nuevo medicamento
          </Button>
        </Col>
        <Col className="flex justify-center w-full flex-col">
          <PatientMedicineTable />
        </Col>
      </Row>
    </div>
  );
};

export default PatientMedicine;
